module.exports = __webpack_public_path__ + "01_mustache_grey.c7054395.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/01_mustache_grey.png
// module id = sFGx
// module chunks = 0